module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "setting-form"
  }, [_c('el-form', {
    staticClass: "settings-form",
    attrs: {
      "label-width": "120px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "display": "none"
    }
  }), _vm._v(" "), (!_vm.expired && !_vm.locked && !_vm.readonly) ? _c('router-link', {
    staticClass: "reupload-btn el-tabs__item",
    attrs: {
      "to": {
        name: 'project_upload',
        params: {
          id: _vm.project.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "ppj-icon-up-big"
  }), _vm._v("更新PPT\n    ")]) : _vm._e(), _vm._v(" "), _c('el-tabs', {
    staticClass: "tabs",
    attrs: {
      "theme": "info",
      "value": _vm.tbcMode ? 'third' : 'first'
    }
  }, [(!_vm.tbcMode) ? _c('el-tab-pane', {
    attrs: {
      "label": "常用设置",
      "name": "first"
    }
  }, [_c('el-form-item', {
    staticClass: "wechat-share",
    attrs: {
      "label": _vm.$t('actions.project.settings.wxshare')
    }
  }, [_c('image-uploader', {
    staticClass: "cover-wrapper",
    attrs: {
      "title": _vm.$t('actions.project.settings.wxcover'),
      "tag": "cover"
    },
    model: {
      value: (_vm.cover),
      callback: function($$v) {
        _vm.cover = $$v
      },
      expression: "cover"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inputs"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('placeholder.project.title')
    },
    model: {
      value: (_vm.form.title),
      callback: function($$v) {
        _vm.form.title = $$v
      },
      expression: "form.title"
    }
  }), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "resize": "false",
      "placeholder": _vm.$t('placeholder.project.description')
    },
    model: {
      value: (_vm.form.description),
      callback: function($$v) {
        _vm.form.description = $$v
      },
      expression: "form.description"
    }
  })], 1)], 1), _vm._v(" "), _c('bgm-setting', {
    ref: "bgm-setting",
    model: {
      value: (_vm.bgmSetting),
      callback: function($$v) {
        _vm.bgmSetting = $$v
      },
      expression: "bgmSetting"
    }
  }), _vm._v(" "), _c('logo-setting', {
    ref: "logo-setting",
    attrs: {
      "editable": _vm.form.allow_to_modify_logo
    },
    model: {
      value: (_vm.logoSetting),
      callback: function($$v) {
        _vm.logoSetting = $$v
      },
      expression: "logoSetting"
    }
  }), _vm._v(" "), _c('permanent-setting', {
    ref: "permanent-setting"
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.tbcMode) ? _c('el-tab-pane', {
    attrs: {
      "label": "高级设置",
      "name": "second"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('actions.project.settings.arrow')
    }
  }, [_c('el-switch', {
    staticClass: "arrow-switch",
    attrs: {
      "width": 35,
      "theme": "info",
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.arrowMode),
      callback: function($$v) {
        _vm.arrowMode = $$v
      },
      expression: "arrowMode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "tansition-ctrl",
    attrs: {
      "label": "翻页控制"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "theme": "info"
    },
    model: {
      value: (_vm.form.transition_ctrl),
      callback: function($$v) {
        _vm.form.transition_ctrl = $$v
      },
      expression: "form.transition_ctrl"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "click"
    }
  }, [_vm._v("\n              默认手动\n            ")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "strict"
    }
  }, [_vm._v("\n              还原PPT\n            ")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "auto-play",
    attrs: {
      "label": _vm.$t('actions.project.settings.autoplayLabel')
    }
  }, [_c('el-radio-group', {
    attrs: {
      "theme": "info"
    },
    model: {
      value: (_vm.form.auto_play),
      callback: function($$v) {
        _vm.form.auto_play = $$v
      },
      expression: "form.auto_play"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "enabled"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('actions.project.settings.autoplay.enabled')) + "\n            ")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "original"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('actions.project.settings.autoplay.original')) + "\n            ")])], 1)], 1), _vm._v(" "), _c('access-setting', {
    ref: "access-setting",
    attrs: {
      "project": _vm.project
    },
    model: {
      value: (_vm.accessSetting),
      callback: function($$v) {
        _vm.accessSetting = $$v
      },
      expression: "accessSetting"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.tbcMode) ? _c('el-tab-pane', {
    attrs: {
      "label": "常用设置",
      "name": "third"
    }
  }, [_c('el-form-item', {
    staticClass: "wechat-share",
    attrs: {
      "label": _vm.$t('actions.project.settings.wxshare')
    }
  }, [_c('image-uploader', {
    staticClass: "cover-wrapper",
    attrs: {
      "title": _vm.$t('actions.project.settings.wxcover'),
      "tag": "cover"
    },
    model: {
      value: (_vm.cover),
      callback: function($$v) {
        _vm.cover = $$v
      },
      expression: "cover"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inputs"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('placeholder.project.title')
    },
    model: {
      value: (_vm.form.title),
      callback: function($$v) {
        _vm.form.title = $$v
      },
      expression: "form.title"
    }
  }), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "resize": "false",
      "placeholder": _vm.$t('placeholder.project.description')
    },
    model: {
      value: (_vm.form.description),
      callback: function($$v) {
        _vm.form.description = $$v
      },
      expression: "form.description"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('actions.project.settings.arrow')
    }
  }, [_c('el-switch', {
    staticClass: "arrow-switch",
    attrs: {
      "width": 35,
      "theme": "info",
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.arrowMode),
      callback: function($$v) {
        _vm.arrowMode = $$v
      },
      expression: "arrowMode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "tansition-ctrl",
    attrs: {
      "label": "翻页控制"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "theme": "info"
    },
    model: {
      value: (_vm.form.transition_ctrl),
      callback: function($$v) {
        _vm.form.transition_ctrl = $$v
      },
      expression: "form.transition_ctrl"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "click"
    }
  }, [_vm._v("\n              默认手动\n            ")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "strict"
    }
  }, [_vm._v("\n              还原PPT\n            ")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "auto-play",
    attrs: {
      "label": _vm.$t('actions.project.settings.autoplayLabel')
    }
  }, [_c('el-radio-group', {
    attrs: {
      "theme": "info"
    },
    model: {
      value: (_vm.form.auto_play),
      callback: function($$v) {
        _vm.form.auto_play = $$v
      },
      expression: "form.auto_play"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "enabled"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('actions.project.settings.autoplay.enabled')) + "\n            ")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "original"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('actions.project.settings.autoplay.original')) + "\n            ")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "page-setup",
    attrs: {
      "label": _vm.$t('actions.project.settings.stretch')
    }
  }, [_c('el-radio-group', {
    attrs: {
      "theme": "info"
    },
    model: {
      value: (_vm.form.stretch_mode),
      callback: function($$v) {
        _vm.form.stretch_mode = $$v
      },
      expression: "form.stretch_mode"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "auto"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('actions.project.settings.stretchValue.auto')) + "\n            ")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "fullscreen"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('actions.project.settings.stretchValue.fullscreen')) + "\n            ")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "restrict"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('actions.project.settings.stretchValue.restrict')) + "\n            ")])], 1)], 1), _vm._v(" "), _c('bgm-setting', {
    ref: "bgm-setting",
    model: {
      value: (_vm.bgmSetting),
      callback: function($$v) {
        _vm.bgmSetting = $$v
      },
      expression: "bgmSetting"
    }
  }), _vm._v(" "), (_vm.project.tbc) ? _c('el-form-item', {
    attrs: {
      "label": "观看设置"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "theme": "info"
    },
    model: {
      value: (_vm.form.tbc.public),
      callback: function($$v) {
        _vm.form.tbc.public = $$v
      },
      expression: "form.tbc.public"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": true
    }
  }, [_vm._v("\n              公开\n            ")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": false
    }
  }, [_vm._v("\n              内部\n            ")])], 1), _vm._v(" "), _c('div', [(_vm.form.tbc.public) ? _c('p', {
    staticClass: "hint"
  }, [_vm._v("所有人都可以通过分享出去的H5链接查看微课")]) : _vm._e(), _vm._v(" "), (!_vm.form.tbc.public) ? _c('p', {
    staticClass: "hint"
  }, [_vm._v("需要验证网络学院账号才可以查看微课")]) : _vm._e()])], 1) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t('common.buttons.save')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.project.settings.cancel')))])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23a49c2e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/show/setting/form/index.vue
// module id = 903
// module chunks = 3